import { CircularProgress } from "@mui/material";

export const Spinner = () => {
return (
<div className="spinner">
    <CircularProgress size={30}/>
</div>
);
}